module.exports = __webpack_public_path__ + "img/01-01_Understanding complex ideas.c87a6df4.svg";